import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import ESSProductManagementView from './views/ESSProductManagementView';

export const essProductManagementRoutes: RouteObject[] = [
    {
        path: '/admin/loan-settings/ess-products',
        element: <ESSProductManagementView />,
        errorElement: <ErrorBoundary />,
    },
];
